import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as ProductCompareHelper from '@project/shared/utils/product-compare/js/product-compare';

const classes = {
	button: 'js-m-product-compare-button__button',
	addedState: 'state-m-product-compare-button--added',
};

@createModule('ProductCompareButton')
/**
 * product-compare-button module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class ProductCompareButton extends TerrificSpec {
	added: boolean = false;
	productId: string;
	productName: string;
	market: string;
	addText: string;
	removeText: string;
	$ctx: JQuery;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.addText = this.$ctx.data('add-text');
		this.removeText = this.$ctx.data('remove-text');
		this.productId = this.$ctx.data('product-id');
		this.productName = this.$ctx.data('product-name');
		this.market = this.$ctx.data('market');
		const $button = this.$ctx.find(`.${classes.button}`);
		$button.on('click', this.onButtonClick.bind(this));

		// the follow event is subscribe the action from compare popup.
		this.$ctx.on('onCompareProductListItemChangeEvent', (e: any, id: string) => {
			if (this.productId === id && this.added) {
				this.changeCompareProductItemState();
			}
		});
		this.initButtonState();
		resolve();
	}

	/**
	 * method sets initial buttons states from cookievalues
	 *
	 * @returns {void}
	 */
	initButtonState() {
		if (ProductCompareHelper.isProductInCookie(this.productId)) {
			this.added = true;
			this.setButtonState();
		}
	}

	/**
	 * method updates button text according to state
	 *
	 * @returns {void}
	 */
	setButtonState() {
		this.$ctx.toggleClass(classes.addedState, this.added);
		const $button = this.$ctx.find(`.${classes.button}`);
		$button.text(this.added ? this.removeText : this.addText);
	}
	/**
	 * method handles button click and updates Cookie accordingly
	 *
	 * @param {Object} ev  eventObject
	 * @returns {void}
	 */
	onButtonClick(ev: Event) {
		ev.preventDefault();
		this.changeCompareProductItemState();
	}

	/**
	 * change compare item state
	 *
	 * @param {Object} ev  eventObject
	 * @returns {void}
	 */
	changeCompareProductItemState() {
		this.added = !this.added;
		this.setButtonState();
		this.updateCookieState();
	}

	/**
	 * method updates cookie state
	 *
	 * @returns {void}
	 */
	updateCookieState() {
		if (this.added) {
			ProductCompareHelper.addProduct(this.productId, this.market, this.productName);
		} else {
			ProductCompareHelper.removeProduct(this.productId);
		}
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
}
